import React from "react";

export const BillNew = () => {
  return <div>BillNew</div>;
};
